import Vue from 'vue'
import StorageLocal from '@/handler/storageLocal'

// Libro contable en el que trabaja el usuario: empresa y Declarado / No declarado.
// Es uno solo para todas las pantallas contables y se recuerda entre sesiones.
// declared: true = Declarado, false = No declarado, null = ambos libros (solo donde se permite).
const STORAGE_KEY = 'accounting_book'

function read() {
  try {
    const saved = JSON.parse(StorageLocal.getValue(STORAGE_KEY) || '{}')
    return {
      business_id: saved.business_id || null,
      declared: saved.declared === true || saved.declared === false ? saved.declared : true,
    }
  } catch (e) {
    return { business_id: null, declared: true }
  }
}

const state = Vue.observable(read())

export const BOOKS = {
  true: { key: 'd', short: 'D', label: 'Declarado', title: 'Libro Declarado' },
  false: { key: 'nd', short: 'ND', label: 'No declarado', title: 'Libro No declarado' },
  null: { key: 'both', short: 'D + ND', label: 'Ambos', title: 'Ambos libros' },
}

export function bookInfo(declared) {
  if(declared === true || declared === 1 || declared === '1') return BOOKS.true
  if(declared === false || declared === 0 || declared === '0') return BOOKS.false
  return BOOKS.null
}

export default {
  state,
  set(businessId, declared) {
    state.business_id = businessId
    state.declared = declared
    try {
      StorageLocal.setValue(STORAGE_KEY, JSON.stringify({ business_id: businessId, declared: declared }))
    } catch (e) {
      // sin almacenamiento local el libro dura lo que la sesión
    }
  },
  // Formato de los filtros que usan '1' / '0' / ''
  declaredParam(declared = state.declared) {
    if(declared === true) return '1'
    if(declared === false) return '0'
    return ''
  },
}
